import { Analytics } from '@vectord/analytics';
import pick from 'lodash/pick';

import { isProduction } from './environment';

const analytics = new Analytics({
  app: 'scm',
  environment: 'scaler',
  shouldTrack: isProduction(),
});

export async function setLoggedInUser(userAnalyticsProfile) {
  if (userAnalyticsProfile) {
    const { user_analytics_id: userAnalyticsId, ...userAttributes } =
      userAnalyticsProfile;

    const EVENT_USER_ATTRIBUTES = [
      'mentee_status',
      'mentee_is_paid',
      'mentee_attendance',
      'mentee_job_search_status',
      'mentee_psp',
      'mentee_super_batch',
      'mentee_total_problem_solved',
      'user_months_of_experience',
      'mentee_degree_enrollment_status',
      'mentee_course_title',
    ];
    analytics.identify(userAnalyticsId);
    analytics.setUserAttributes(userAttributes);

    const superAttributes = pick(userAttributes, ['user_email']);
    analytics.setSuperAttributes(superAttributes);

    const eventUserAttributes = pick(userAttributes, EVENT_USER_ATTRIBUTES);
    analytics.setEventUserAttributes(eventUserAttributes);
  }
}

export default analytics;
